import Ionicons from '@expo/vector-icons/Ionicons';
import type { ComponentProps } from 'react';
import {
  StyleSheet,
  type UnistylesVariants,
  withUnistyles,
} from 'react-native-unistyles';

type IconProps = UnistylesVariants<typeof style> &
  Omit<ComponentProps<typeof Ionicons>, 'size'>;

const UnistylesIcon = withUnistyles(Ionicons);

export default function Icon({
  name,
  variant = 'typography',
  size = 'xl',
  color,
  ...rest
}: IconProps) {
  style.useVariants({
    size,
    variant,
  });

  return (
    <UnistylesIcon
      uniProps={(theme) => {
        return {
          name,
          size: theme.fontSize[size],
          color: color ?? theme.colors[variant],
        };
      }}
      {...rest}
    />
  );
}

const style = StyleSheet.create((theme) => ({
  text: {
    variants: {
      size: {
        '9xl': {
          fontSize: theme.fontSize['9xl'],
        },
        '8xl': {
          fontSize: theme.fontSize['8xl'],
        },
        '7xl': {
          fontSize: theme.fontSize['7xl'],
        },
        '6xl': {
          fontSize: theme.fontSize['6xl'],
        },
        '5xl': {
          fontSize: theme.fontSize['5xl'],
        },
        '4xl': {
          fontSize: theme.fontSize['4xl'],
        },
        '3xl': {
          fontSize: theme.fontSize['3xl'],
        },
        '2xl': {
          fontSize: theme.fontSize['2xl'],
        },
        xl: {
          fontSize: theme.fontSize.xl,
        },
        lg: {
          fontSize: theme.fontSize.lg,
        },
        md: {
          fontSize: theme.fontSize.md,
        },
        sm: {
          fontSize: theme.fontSize.sm,
        },
        xs: {
          fontSize: theme.fontSize.xs,
        },
      },
      variant: {
        primary: {
          color: theme.colors.primary,
        },
        secondary: {
          color: theme.colors.secondary,
        },
        error: {
          color: theme.colors.error,
        },
        success: {
          color: theme.colors.success,
        },
        info: {
          color: theme.colors.info,
        },
        warning: {
          color: theme.colors.warning,
        },
        typography: {
          color: theme.colors.typography,
        },
        typographyInverted: {
          color: theme.colors.typographyInverted,
        },
        typographySecondary: {
          color: theme.colors.typographySecondary,
        },
        typographyMuted: {
          color: theme.colors.typographyMuted,
        },
        white: {
          color: theme.colors.white,
        },
        black: {
          color: theme.colors.black,
        },
      },
    },
  },
}));
